import { render, staticRenderFns } from "./g1g1.vue?vue&type=template&id=063cefd1&scoped=true&"
import script from "./g1g1.vue?vue&type=script&lang=js&"
export * from "./g1g1.vue?vue&type=script&lang=js&"
import style0 from "./g1g1.vue?vue&type=style&index=0&id=063cefd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063cefd1",
  null
  
)

export default component.exports